import { render, staticRenderFns } from "./MoleculeContentEditorDropDownIcons.vue?vue&type=template&id=472a87ce&"
import script from "./MoleculeContentEditorDropDownIcons.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentEditorDropDownIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports